import {IAction} from '../../interfaces';

export enum ClientStatusActions {
  CLIENT_STATUS_CHECK = '[ClientStatus] check',
  CLIENT_STATUS_CHECK_SUCCESS = '[ClientStatus] check success',

}

export class ClientStatusCheck implements IAction {
  readonly type = ClientStatusActions.CLIENT_STATUS_CHECK;
}

export class ClientStatusCheckSuccess implements IAction {
  readonly type = ClientStatusActions.CLIENT_STATUS_CHECK_SUCCESS;

  constructor(public payload: boolean) {
  }
}
